import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { useEffect, useState } from 'react'

import useCertificateGenerator from '../../hooks/api/certificates/useCertificateGenerator'
import { getProtectedS3 } from '../../hooks/useS3Storage'
import NBDriverIDViewer from '../components/certificates/NBDriverID'
import RecordCheckCertificateViewer from '../components/certificates/RecordCheck'

const NB_DRIVER_ID_FILENAME = 'NB Driver ID'
const NB_DRIVER_ID_HTML_ELEMENT = 'nb_driver_id'
const BC_RECORD_CHECK_CERTIFICATE_FILENAME = 'Record_Certificate'
const BC_RECORD_CHECK_CERTIFICATE_HTML_ELEMENT = 'certificate'

const CertificatePage = ({ data }) => {
  const { generatePDF } = useCertificateGenerator()
  const [recordCheckDocument, setRecordCheckDocument] = useState<string>('')

  const getRCCertificateFile = async (file: string) => {
    try {
      const doc = await getProtectedS3(file)
      setRecordCheckDocument(doc.href)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    getRCCertificateFile(
      'certificates/BC-record-check-certificate-template.png'
    )
  }, [])

  return (
    <RecordCheckCertificateViewer
      generatePDF={() =>
        generatePDF(
          data.full_name,
          data.vehicle.plate_number,
          BC_RECORD_CHECK_CERTIFICATE_FILENAME,
          BC_RECORD_CHECK_CERTIFICATE_HTML_ELEMENT
        )
      }
      templateImage={recordCheckDocument}
      user={data}
    />
  )
}

const NBDriverIDPage = ({ data }) => {
  const { generatePDF } = useCertificateGenerator()
  const [bcDriverIDDocument, setBCDriverIDDocument] = useState<string>('')

  const getBCDriverIDFile = async (file: string) => {
    try {
      const doc = await getProtectedS3(file)
      setBCDriverIDDocument(doc.href)
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    getBCDriverIDFile('certificates/BC-driver-ID-template.png')
  }, [])

  return (
    <NBDriverIDViewer
      generatePDF={() =>
        generatePDF(
          data.full_name,
          data.vehicle.plate_number,
          NB_DRIVER_ID_FILENAME,
          NB_DRIVER_ID_HTML_ELEMENT
        )
      }
      templateImage={bcDriverIDDocument}
      user={data}
    />
  )
}

const CertificateDialog = ({ content, onClose, open, textToClose, title }) => (
  <Dialog fullWidth maxWidth="md" onClose={onClose} open={open}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    <DialogActions>
      <Button color="primary" onClick={onClose}>
        {textToClose}
      </Button>
    </DialogActions>
  </Dialog>
)

export { CertificateDialog, CertificatePage, NBDriverIDPage }
